export default __webpack_public_path__ + "static/media/polygon-icon.07c31076.svg";